import Footer from '../commons/Footer'
import Navbar from '../commons/Navbar'

import breadcrumbshape1 from '../img/breadcrumb/breadcrumb-shape-1.png'
import breadcrumbshape2 from '../img/breadcrumb/breadcrumb-shape-2.png'
import breadcrumbsub1 from '../img/breadcrumb/breadcrumb-sub-1.png'


const PrivacyPolicy = () => {
  return (
    <div>
      {/* tp-offcanvus-area-start */}

      <div className="body-overlay" />
      {/* tp-offcanvus-area-end */}
      <Navbar />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main>
            {/* breadcrumb-area-start */}
            <div className="breadcrumb__area breadcrumb-height p-relative blue-bg-2">
              <div className="breadcrumb__shape-1">
                <img src={breadcrumbshape1} alt="" />
              </div>
              <div className="breadcrumb__shape-2">
                <img src={breadcrumbshape2} alt="" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-8 col-lg-7">
                    <div className="breadcrumb__content">
                      <h5 className="breadcrumb__title tp-char-animation">
                        Privacy Policy
                      </h5>
                      <div className="breadcrumb__list tp-title-anim">
                        <span className="child-one">
                          <a
                            href="/"
                            style={{ textDecoration: 'none', color: 'white' }}
                          >
                            Home
                          </a>
                        </span>
                        <span className="dvdr">
                          <i className="fal fa-angle-right" />
                        </span>
                        <span className="dvdr">
                        </span>
                        <span>PrivacyPolicy</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-5 col-lg-4 text-center text-md-end">
                    <div className="breadcrumb__img p-relative text-start z-index">
                      <div
                        className="breadcrumb__sub-img wow tpfadeUp"
                        data-wow-duration=".9s"
                        data-wow-delay=".4s"
                      >
                        <img src={breadcrumbsub1} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* breadcrumb-area-end */}
            {/* service-details-area-start */}
            <div className="bg-white text-black min-h-screen flex justify-center items-start py-10 px-4">
                <div className="w-full max-w-4xl break-words">
                    <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
                    <p className="mb-4">
                    Website is owned and operated by LONO (Lono Services Private Limited)
                    </p>

                    <h5 className="text-2xl font-semibold mb-2">Information Collection</h5>
                    <p className="mb-4">
                    Personal information gathered and stored to give you better service. We may gather,
                    retain, and make use of the following types of data:
                    </p>
                    <ul className="list-disc list-inside mb-4">
                    <li>Your name, contact information, company name, email address, phone number, and fax number</li>
                    <li>History of our communications with you</li>
                    <li>Areas of interest (industries, events, publications, etc.)</li>
                    </ul>

                    <h5 className="text-2xl font-semibold mb-2">Usage of Personal Data</h5>
                    <ul className="list-disc list-inside mb-4">
                    <li>Permit access to the information on the website</li>
                    <li>Provide email alerts you have requested</li>
                    <li>
                        Send newsletters, invitations, and other relevant information by mail or email if you have
                        consented. You can opt out anytime.
                    </li>
                    </ul>

                    <h5 className="text-2xl font-semibold mb-2">Protection and Storage</h5>
                    <p className="mb-4">
                    We implement organizational and technical safeguards to protect your data. All personal data
                    is stored on secure, password- and firewall-protected servers. Only authorized personnel may
                    access it.
                    </p>

                    <h5 className="text-2xl font-semibold mb-2">Cookies</h5>
                    <p className="mb-4">
                    We use both session and persistent cookies:
                    </p>
                    <ul className="list-disc list-inside mb-4">
                    <li>Session cookies are deleted after you close your browser</li>
                    <li>Persistent cookies remain until deleted or expired</li>
                    </ul>
                    <p className="mb-4">
                    Cookies are used to track usage and personalize your experience. We also use Google Analytics to gather
                    statistics. You can read their policy at{' '}
                    <a href="https://www.google.com/privacypolicy.html" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                        www.google.com/privacypolicy.html
                    </a>.
                    </p>
                    <p className="mb-4">
                    Most browsers allow you to reject cookies, but doing so may reduce website usability.
                    </p>

                    <h5 className="text-2xl font-semibold mb-2">Policy Amendments</h5>
                    <p className="mb-4">
                    We may occasionally update this privacy policy. Please check this page regularly to ensure
                    you are happy with any changes.
                    </p>

                    <h5 className="text-2xl font-semibold mb-2">Updating Information / Contact</h5>
                    <p className="mb-4">
                    For questions or updates to your information, please email us at:{' '}
                    <a href="mailto:help@lono.org.in" className="text-blue-600 underline">help@lono.org.in</a>
                    </p>
                </div>
            </div>

            {/* service-details-area-end */}
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
